<template>
  <el-row class="articleContent">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >公共服务</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >信息查询服务</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ regulations.laws }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="grid-content bg-purple-dark">
        <p class="tlt1">{{ regulations.laws }}</p>
        <p class="tlt3">
          浏览次数：<span>{{ regulations.num }}</span>
        </p>
        <p class="tlt2">
          （<span>{{ regulations.time }}</span>
          数据来源：国家文物局博物馆与社会文物司）
        </p>
        <div class="hxl_title"></div>
      </div>
      <div class="announcement">
        <div class="ipt">
          <el-input
            v-model="searchOn"
            maxlength="24rem"
            placeholder="请输入名称/法定代表人"
            class="input-with-select"
          >
            <el-button
              class="searchFor"
              slot="append"
              size="small"
              @click="seeSer()"
              >搜索</el-button
            >
          </el-input>
          <el-button size="small" class="reset" @click="resetOn()"
            >重置</el-button
          >
        </div>
        <div class="dat">
          <div class="paging">
            <el-select
              v-model="province"
              clearable
              placeholder="省份"
              class="province"
              @change="provinceChange()"
            >
              <el-option
                v-for="item in provinceList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="subjectType"
              clearable
              placeholder="主体类型"
              class="subjectType"
              @change="subjectTypeChange()"
            >
              <el-option
                v-for="item in subjectTypeList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
            <!-- <el-select
              v-model="status"
              clearable
              placeholder="资质状态"
              class="status"
              @change="statusChange()"
            >
              <el-option
                v-for="item in statusList"
                :key="item.code"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select> -->
          </div>
          <div>
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="refresh"
              @click="refresh()"
              >刷新</el-button
            >
          </div>
        </div>
        <div style="padding: 0 20px; text-align: center">
          <el-table
            :data="legalForms"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              label="总序号"
              :index="count"
              width="76px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="proName"
              label="注册地"
              min-width="100px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="thName"
              label="主体类型"
              min-width="100px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="classNum"
              label="省内分类序号"
              width="120"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="organizationName"
              label="名称"
              min-width="228px"
            >
            </el-table-column>

            <!-- <el-table-column
              align="center"
              prop="legalRepresentative"
              label="法定代表人"
              min-width="120px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="licenseNum"
              label="许可证号、批准文号或统一社会信用代码"
              min-width="270px"
            >
            </el-table-column> -->
            <el-table-column
              align="center"
              prop="remark"
              label="备注"
              min-width="90px"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            popper-class="pageclass"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import {
  URL_DATACRAUCTION,
  URL_COMPREHENSIVE_EXCUSE,
  URL_DESCRIPTION_FIND,
} from "../../../utils/api";
import util from "../../../utils/util";
import { frontHeater } from "../../../utils/md5encryption";
export default {
  props: [],
  inject: ["reload"],
  components: {},
  data() {
    return {
      // 基本数据
      regulations: {
        //  标题+面包屑
        laws: "全国文物商店、文物拍卖企业名单",
        // 浏览次数
        num: "2",
        // 更新时间
        time: "",
      },
      // 省份
      provinceList: [],
      // 省份
      province: null,
      //资质状态
      // statusList: [],
      //资质状态
      status: null,
      // 主体类型
      subjectTypeList: [],
      // 主体类型
      subjectType: null,
      //   搜索
      searchOn: null,
      // 表格
      legalForms: [],
      // 前往页数
      currentPage: 1,
      // 总条数
      total: 100,
      //   单选按钮
      pagesize: 20,
    };
  },
  computed: {},
  mounted() {
    this.getDate();
    this.getList();
    this.getProvinceList();
    this.getThemeTypeList();
    // this.getAuctQualificationStatusName();
    this.getNumberViews();
  },
  methods: {
    // 请求数据列表
    getList() {
      let result = frontHeater(
        ["districtCode", "themeType"],
        [this.province, this.subjectType]
      );
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pagesize,
        keywords: this.searchOn,
        districtCode: this.province,
        themeType: this.subjectType,
        auctQualificationStatusName: this.status,
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["districtCode"] = this.province;
      this.$http.defaults.headers.common["themeType"] = this.subjectType;
      this.$http
        .get(Url + URL_DATACRAUCTION, {
          params,
        })
        .then((res) => {
          if (res.status == 200) {
            this.legalForms = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    formatDateB() {
      let date = new Date(); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let m = date.getMonth() + 1,
        mm = m < 10 ? "0" + m : m;
      let d = date.getDate(),
        dd = d < 10 ? "0" + d : d;
      return date.getFullYear() + "年" + mm + "月" + dd + "日";
    },
    getDate() {
      this.regulations.time = "更新时间：" + this.formatDateB();
    },
    //获取省份
    getProvinceList() {
      let result = frontHeater(["ClassCode"], ["DistrictCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "DistrictCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "DistrictCode";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.provinceList = res.data.data;
        }
      });
    },
    // 主体类型
    getThemeTypeList() {
      let result = frontHeater(["ClassCode"], ["ThemeType"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "ThemeType",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "ThemeType";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.subjectTypeList = res.data.data;
        }
      });
    },
    // 资质状态
    // getAuctQualificationStatusName() {
    //   let result = frontHeater(["ClassCode"], ["AuctQualificationStatusCode"]);
    //   let Url = util.getAjaxUrl("axiosTWo");
    //   let params = {
    //     ClassCode: "AuctQualificationStatusCode",
    //   };
    //   this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
    //   this.$http.defaults.headers.common["secretSign"] =
    //     result.encryptionString;
    //   this.$http.defaults.headers.common["secretDefinite"] =
    //     result.parameterKey;
    //   this.$http.defaults.headers.common["appCode"] = result.secret;
    //   this.$http.defaults.headers.common["ClassCode"] =
    //     "AuctQualificationStatusCode";
    //   this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
    //     if (res.status == 200) {
    //       this.statusList = res.data.data;
    //     }
    //   });
    // },
    // 获取浏览次数
    getNumberViews() {
      let result = frontHeater(["dataType"], ["DataCrAuctionOrganization"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        dataType: "DataCrAuctionOrganization",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["dataType"] =
        "DataCrAuctionOrganization";
      this.$http.post(Url + URL_DESCRIPTION_FIND, params).then((res) => {
        if (res.status === 200) {
          this.regulations.num = res.data.data.viewTimes;
        }
      });
    },
    // 解决换页后index从1开始
    count(index) {
      return (this.currentPage - 1) * this.pagesize + index + 1;
    },
    // 搜索
    seeSer() {
      this.getList();
    },
    // 重置
    resetOn() {
      this.searchOn = null;
      this.province = null;
      this.subjectType = null;
      this.status = null;
      this.currentPage = 1;
      this.getList();
    },
    // 刷新
    refresh() {
      this.resetOn();
    },
    // 表格分页
    handleSizeChange(val) {
      this.pagesize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    provinceChange() {
      this.getList();
    },
    subjectTypeChange() {
      this.getList();
    },
    // statusChange() {
    //   this.getList();
    // },
  },
};
</script>
<style scoped lang='less'>
@import "../../../styles/theme";
@import "../../../styles/comSty";
@import "../../../styles/Hierarchy";
.tlt1 {
  font-size: 18px;
  font-weight: 700;
  color: #b71c1c;
  margin: 10px 0;
  text-align: center;
}
.tlt2 {
  margin: 0;
  text-align: center;
  font-size: 16px;
}
.tlt3 {
  margin: 0 auto;
  padding-right: 40px;
  text-align: right;
  font-size: 16px;
  color: #444;
  font-weight: 700;
  span {
    color: @theme-color;
  }
}

.hxl_title {
  font-size: 22px;
  padding-bottom: 10px;
  color: #b71c1c;
  border-bottom: 3px solid #b71c1c;
}
.province {
  width: 170px;
}
.subjectType,
.status {
  width: 150px;
}
.dat {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin: 10px 0;
  align-items: center;
}
</style>
